import { render, staticRenderFns } from "./RealmDashboard.vue?vue&type=template&id=47298f34&scoped=true"
import script from "./RealmDashboard.vue?vue&type=script&lang=js"
export * from "./RealmDashboard.vue?vue&type=script&lang=js"
import style0 from "./RealmDashboard.vue?vue&type=style&index=0&id=47298f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47298f34",
  null
  
)

export default component.exports